import {createSelector} from "reselect";

import {NameSpace} from "../name-space";
import {getActiveAreaId, getActiveDataMode, getActivePeriodId, getActivePoolId} from "../application/selectors";
import {getPoolsTotalResearches} from "../../utils/utils";


const NAME_SPASE = NameSpace.DATA;


const getCurrentPeriod = (state) => {
  return state[NAME_SPASE].current;
};

const getPeriods = (state) => {
  return state[NAME_SPASE].periods;
};

const getArchive = (state) => {
  return state[NAME_SPASE].archive;
};

const getPools = (state) => {
  return state[NAME_SPASE].pools;
};

const getDataError = (state) => {
  return state[NAME_SPASE].dataError;
};

const getActivePeriod = createSelector(
    getActivePeriodId,
    getCurrentPeriod,
    getPeriods,
    (activePeriodId, currentPeriod, periods) => {
      const periodId = activePeriodId || currentPeriod.periodId;
      const activePeriod = periods ?
        periods.find((period) => period.periodId === periodId) || null
        : currentPeriod;

      return activePeriod;
    }
);

const getActivePool = createSelector(
    getPools,
    getActivePoolId,
    (pools, poolId) => {
      return pools
        ? pools.find((pool) => pool.id === poolId)
        : null;
    }
);

const getActiveArea = createSelector(
    getActivePool,
    getActiveAreaId,
    (pool, areaId) => {
      if (areaId) {
        const area = pool.catchAreas.find((areaItem) => areaItem.id === areaId) || null;
        return area;
      }

      return null;
    }
);

const getCatchAreasCount = createSelector(
    getPools,
    (pools) => {
      const count = pools.length
        ? pools.reduce((accumulator, pool) => accumulator + pool.catchAreas.length, 0)
        : 0;

      return count;
    }
);

const getTotalResearches = createSelector(
    getPools,
    getActiveDataMode,
    (pools, dataMode) => {
      return getPoolsTotalResearches(pools, dataMode);
    }
);

const getPoolById = createSelector(
    getPools,
    (state, id) => id,
    (pools, id) => {
      return pools
        ? pools.find((pool) => pool.id === id)
        : null;
    }
);


export {
  getArchive,
  getActiveArea,
  getActivePeriod,
  getActivePool,
  getDataError,
  getCurrentPeriod,
  getCatchAreasCount,
  getPeriods,
  getPools,
  getPoolById,
  getTotalResearches,
};
